module.exports = __webpack_public_path__ + "img/home_pic_separate.4b1793c6.png";